import { useState } from "react";

/** Compact legend for colour-coded 3D buildings. */
const SWATCHES: Array<{ label: string; labelTh: string; color: string }> = [
  { label: "Health", labelTh: "สุขภาพ", color: "rgb(239, 68, 68)" },
  { label: "Civic", labelTh: "ราชการ", color: "rgb(56, 189, 248)" },
  { label: "School", labelTh: "การศึกษา", color: "rgb(167, 139, 250)" },
  { label: "Temple", labelTh: "วัด", color: "rgb(253, 224, 71)" },
  { label: "Shop", labelTh: "พาณิชย์", color: "rgb(245, 158, 11)" },
  { label: "Office/Bank", labelTh: "ธนาคาร", color: "rgb(45, 170, 160)" },
  { label: "Home", labelTh: "ที่อยู่อาศัย", color: "rgb(210, 110, 65)" },
  { label: "Fabric", labelTh: "อาคารทั่วไป", color: "rgb(165, 138, 112)" },
];

/**
 * MSH: this was an always-open 171x215 panel pinned over the map's
 * bottom-right, naming eight categories nobody had asked about yet, on
 * every lens and every load. It is a *reference* for reading the map, not
 * the map's content — so it now costs a single strip of swatches (which
 * still says "buildings are colour-coded, here are the colours") until
 * someone asks which colour means what.
 */
export function BuildingLegend() {
  const [open, setOpen] = useState(false);

  return (
    <div className={`building-legend${open ? " building-legend--open" : ""}`}>
      <button
        type="button"
        className="building-legend-toggle mono"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={open ? "Hide building colour legend" : "Show which colour means which building type"}
      >
        <span className="building-legend-title mono">BUILDINGS · สีอาคาร</span>
        <span aria-hidden className="building-legend-caret">{open ? "▾" : "▸"}</span>
      </button>

      {/* Collapsed state still carries the colour information itself, so the
          reader can match a building to a swatch without opening anything. */}
      {!open && (
        <div className="building-legend-strip" aria-hidden>
          {SWATCHES.map((s) => (
            <span
              key={s.label}
              className="building-legend-swatch"
              style={{ background: s.color }}
            />
          ))}
        </div>
      )}

      {open && (
        <ul className="building-legend-list">
          {SWATCHES.map((s) => (
            <li key={s.label}>
              <span className="building-legend-swatch" style={{ background: s.color }} />
              <span>
                {s.labelTh}
                <span className="building-legend-en mono"> {s.label}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}